'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export function BodyClassHandler() {
  const pathname = usePathname();

  useEffect(() => {
    // Remove leading/trailing slashes and split
    const segments = pathname?.replace(/^\/+|\/+$/g, '').split('/') || [];
    // If the path is just the locale (e.g., /en-us) or root, treat as home
    let slug = 'home';
    if (segments.length > 1) {
      // Use the last non-empty segment as the slug
      slug = segments[segments.length - 1] || 'home';
    } else if (segments.length === 1 && segments[0] && segments[0].length > 2) {
      // If the only segment is not a locale (e.g., /about), use it
      slug = segments[0];
    }
    const className = `page-${slug}`;

    // Add the new class
    document.body.classList.add(className);

    // Cleanup function to remove the class when component unmounts
    return () => {
      document.body.classList.remove(className);
    };
  }, [pathname]);

  return null;
}
